const ShippingMethod = {
  colissimo: 'C',
  colieco: 'CE',
  relay: 'RP',
  standardPackage: 'SP',
  mondialRelay: 'MLR',
};

export default ShippingMethod;
